import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { QuyTrinhXuLyThietBiService } from './quy-trinh-xu-ly-thiet-bi.service';
import { AuthService } from '../services/auth.service';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { DmCongViecService } from '../danhmuc/dm-cong-viec/dm-cong-viec.service';
import { CongViec } from '../danhmuc/dm-cong-viec/dm-cong-viec';
import { QuyTrinhXuLyThietBi } from './quy-trinh-xu-ly-thiet-bi';
import { DMThietBi } from '../thiet-bi/dm-thiet-bi/dm-thiet-bi';
import { DMThietBiService } from '../thiet-bi/dm-thiet-bi/dm-thiet-bi.service';

import { DMCoQuan } from '../he-thong/dm-co-quan/dm-co-quan';
import { DMCoQuanService } from '../he-thong/dm-co-quan/dm-co-quan.service';

import { DMDonVi } from '../he-thong/dm-don-vi/dm-don-vi';
import { DMDonViService } from '../he-thong/dm-don-vi/dm-don-vi.service';

import { BuocThucHien } from '../quy-trinh-xu-ly/buoc-thuc-hien';
import { BuocThucHienService } from '../quy-trinh-xu-ly/buoc-thuc-hien.service';

import { CauHinhSMSQuyTrinh } from '../quy-trinh-xu-ly/cau-hinh-sms-quy-trinh';
import { CauHinhSMSQuyTrinhService } from '../quy-trinh-xu-ly/cau-hinh-sms-quy-trinh.service';
import { CauHinhEmailQuyTrinhService } from './cau-hinh-email-quy-trinh.service';

import { MucDoUuTien } from '../danhmuc/dm-muc-do-uu-tien/muc-do-uu-tien';
import { MucDoUuTienService } from '../danhmuc/dm-muc-do-uu-tien/muc-do-uu-tien.service';

import { NhanVien } from '../he-thong/nhan-vien/nhan-vien';
import { NhanVienService} from '../he-thong/nhan-vien/nhan-vien.service';
import { MucDoUuTienQuyTrinh } from '../quy-trinh-xu-ly/muc-do-uu-tien-quy-trinh';
import { DMLoaiThietBiService } from '../thiet-bi/dm-loai-thiet-bi/dm-loai-thiet-bi.service';
import { DMLoaiThietBi } from '../thiet-bi/dm-loai-thiet-bi/dm-loai-thiet-bi';

import { DMDongTBService } from '../thiet-bi/dm-dong-thiet-bi/dm-dong-thiet-bi.service';
import { DMDongTB } from '../thiet-bi/dm-dong-thiet-bi/dm-dong-thiet-bi';
import { DMHangSanXuat, IDMHangSanXuat } from '../thiet-bi/dm-hang-san-xuat/dm-hang-san-xuat';
import { DMHangSanXuatService } from '../thiet-bi/dm-hang-san-xuat/dm-hang-san-xuat.service';

import { TrangThai } from '../danhmuc/dm-trang-thai/trang-thai';
import { TrangThaiService } from '../danhmuc/dm-trang-thai/trang-thai.service';

import { DMKetQuaXuLyService } from '../danhmuc/dm-ketquaxuly/dm-ketquaxuly.service';
import { CauHinhBuoc } from '../quy-trinh-xu-ly/cau-hinh-buoc';
import { CauHinhBuocService } from '../quy-trinh-xu-ly/cau-hinh-buoc.service';
import { QuyTrinhXuLyService } from '../quy-trinh-xu-ly/quy-trinh-xu-ly.service';

declare var jQuery: any;
declare var $: any;
@Component({
    selector: 'vnpt-quy-trinh-xu-ly-thiet-bi',
    templateUrl: './quy-trinh-xu-ly-thiet-bi.component.html',
    providers: [QuyTrinhXuLyThietBiService,
        AuthService,
        DmCongViecService,
        DMThietBiService,
        BuocThucHienService,
        DMCoQuanService,
        DMDonViService,
        CauHinhSMSQuyTrinhService,
        CauHinhEmailQuyTrinhService,
        DMLoaiThietBiService,
        TrangThaiService,
        DMDongTBService,
        DMKetQuaXuLyService,
        CauHinhBuocService,
        DMHangSanXuatService,
        MucDoUuTienService,
        NhanVienService,
        QuyTrinhXuLyService]
})
export class QuyTrinhXuLyThietBiComponent implements OnInit {
    @ViewChild("divCongViec") divCongViec: ElementRef;
    //@ViewChild("divCoQuan") divCoQuan: ElementRef;
    @ViewChild("divMaQuyTrinh") divMaQuyTrinh: ElementRef;
    @ViewChild("divTrangThai") divTrangThai: ElementRef;
    @ViewChild("divGhiChu") divGhiChu: ElementRef;

    title: string = "Quy trình";
    changeAddUpdate: string = "Thêm mới";
    mListQuyTrinh: QuyTrinhXuLyThietBi[] = [];

    mListQuyTrinhIndex: QuyTrinhXuLyThietBi[] = [];
    mQuyTrinh: QuyTrinhXuLyThietBi;
    mListSanPham: DMThietBi[];
    mListBuocThucHien: BuocThucHien[] = [];
    mListBuocThucHienTemp: BuocThucHien[] = [];
    mBuocThucHien: BuocThucHien;

    mIdMucDoQuyTrinh: number = 1;
    mListCauHinhSMSQuyTrinh: CauHinhSMSQuyTrinh[] = [];
    mListCauHinhSMSQuyTrinhTemp: CauHinhSMSQuyTrinh[] = [];
    mCauHinhSMSQuyTrinh: CauHinhSMSQuyTrinh;

    mListMucDoQuyTrinh: MucDoUuTienQuyTrinh[] = [];

    mListCongViec: CongViec[] = [];
    mListCoQuan: DMCoQuan[] = [];
    mListDonVi: DMDonVi[] = [];
    mListMucDoUuTien: DMDonVi[] = [];

    mListDonViCauHinhSMS: DMDonVi[] = [];
    mDonViCauHinhSMS: DMDonVi;
    showNhanVien: boolean = false;
    savingNhanVien: boolean = false;
    thongBaoLuuNhanVien: boolean = false;
    mListNhanVienQuyTrinh: NhanVien[] = [];
    mListNhanVienNhanSMSQuyTrinh: NhanVien[] = [];

    mListTrangThai: TrangThai[] = [];

    dongMoDropdown: boolean = false;
    dongMoDropdownSMS: boolean = false;
    donviChon: any = { name: '--- Chọn đơn vị ---', id: 0 };
    donviChonSMS: any = { name: '--- Chọn đơn vị ---', id: 0 };
    TT: boolean = false;
    TTSMS: boolean = false;
    saveStatusMessage: string = "";
    saveStatus: boolean = false;
    pagingQuyTrinh: number = 1;
    totalCountQuyTrinh: number = 0;
    totalPagesQuyTrinh: number = 1;
    totalQuyTrinh: number;
    keywordQuyTrinh: string = '';
    size: number = 10;

    IdDonVi: number = this.auth.user.IdDonVi;
    IdQuyTrinhCoppy: number = 0;

    dmThietBiTreeData: any;
    thietbiChonGlobal: any = { name: '--- Chọn nhóm ---', id: 0 };
    idThietBi: number = 0;
    idDonVi: any = this.auth.user.IdDonVi;
    idLoaiThietBi: number = 0;
    listItemThietBi: DMThietBi[] = [];
    mListTemp: DMThietBi[] = [];
    dongMoDropdownThietBi: boolean = false;
    coppingThietBi: boolean = false;
    isNhomThietBi: boolean = true;
    listLoaiThietBi: DMLoaiThietBi[] = [];
    listDongThietBI: DMDongTB[] = [];
    listHangSanXuat: IDMHangSanXuat[] = [];
    idLoaiThietBiSearch: number = 0;
    idDongThietBiSearch: number = 0;
    idHangThietBiSearch: number = 0;

    success: boolean = false;
    error: boolean = false;
    status: boolean = false;
    successMessage: string = "";
    errorMessage: string = "";
    statusMessage: string = "";

    errorPop: boolean = false;
    statusPop: boolean = false;
    messagePop: string = "";

    mListBuocSelect: BuocThucHien[] = [];
    mListKetQua: any[] = [];
    mListKetQuaTemp: any[] = [];
    mListCauHinhBuoc: CauHinhBuoc[] = [];
    mListBuocSelectTemp: BuocThucHien[] = [];

    idLoaiQuyTrinhSearch: number;

    constructor(private router: Router,
        private serviceNV:NhanVienService,
        private route: ActivatedRoute,
        private service: QuyTrinhXuLyThietBiService,
        private serviceSanPham: DMThietBiService,
        private serviceBuocThucHien: BuocThucHienService,
        private serviceCauHinhSMS: CauHinhSMSQuyTrinhService,
        private serviceCauHinhEmail: CauHinhEmailQuyTrinhService,
        private serviceCoQuan: DMCoQuanService,
        private serviceMucDoUuTien: MucDoUuTienService,
        private serviceDonVi: DMDonViService,
        private loaithietbiService: DMLoaiThietBiService,
        private serviceTrangThai: TrangThaiService,
        private hangsanxuatservice: DMHangSanXuatService,
        private dongThietBiService: DMDongTBService,
        private serviceKQXL: DMKetQuaXuLyService,
        public auth: AuthService,
        private serviceCauHinhBuoc: CauHinhBuocService,
        private congviecService: DmCongViecService,
        private svQTXL: QuyTrinhXuLyService) { }

    ngOnInit() {
        this.Reset();
        this.idLoaiQuyTrinhSearch = -1;
        this.GetListCongViec();
        this.GetListTrangThai();
        this.GetListCoQuan();
        this.GetListMucDoUuTien();
        this.GetListLoaiThietBi();
        this.GetHangSanXuat();
        this.GetListDongThietBi();
        this.route.params.subscribe(val => this.Init());
    }

    Init() {
        this.route.params.subscribe(params => {
            if (params['keyword']) {
                this.keywordQuyTrinh = $.trim(params['keyword']) == '$' ? '' : $.trim(params['keyword']);
            }
            if (params['idloaithietbi']) {
                this.idLoaiThietBiSearch = params['idloaithietbi'];
            }
            if (params['idhangsanxuat']) {
                this.idHangThietBiSearch = params['idhangsanxuat'];
            }
            if (params['iddongthietbi']) {
                this.idDongThietBiSearch = params['iddongthietbi'];
            }
            if (params['idtrangthai']) {
                this.idLoaiQuyTrinhSearch = params['idtrangthai'];
            }
        });

        this.GetListQuyTrinh(this.pagingQuyTrinh);
    }

    search() {
        var keyword_tmp = (this.keywordQuyTrinh == '') ? '$' : this.keywordQuyTrinh;
        this.router.navigate(['quy-trinh-xu-ly-thiet-bi/', keyword_tmp, this.idLoaiThietBiSearch, this.idHangThietBiSearch, this.idDongThietBiSearch, this.idLoaiQuyTrinhSearch]);
        this.GetListQuyTrinh(this.pagingQuyTrinh);
    }

    chonidLoaiQuyTrinhSearch() {
        this.GetListQuyTrinh(1);
    }
    GetListQuyTrinh(paging: number, showAlert: boolean = true) {
        if (showAlert)
            this.ShowAlert("Đang load danh sách quy trình ...", "status");
        this.service.GetList(paging, this.size, this.keywordQuyTrinh, this.idLoaiThietBiSearch, this.idHangThietBiSearch, this.idDongThietBiSearch, this.idLoaiQuyTrinhSearch)
            .subscribe(
            (data) => {
                this.HideAlert("status");
                this.mListQuyTrinh = data;                
                if (this.mListQuyTrinh.length !== 0) {
                    this.pagingQuyTrinh = paging;
                    this.totalCountQuyTrinh = (data[0]).TotalRows;
                    this.totalPagesQuyTrinh = Math.ceil(this.totalCountQuyTrinh / this.size); // tính tổng số trang cần phân dựa vào tổng records
                } else {
                    if (paging > 1) {
                        this.GetListQuyTrinh(paging - 1);
                    } else {
                        this.totalPagesQuyTrinh = 0;
                    }
                }

            },
            er => {
                if (er.status == 401) {
                    this.router.navigate(['./login']);
                }
            });
    }

    // hàm thực thi tìm kiếm khi người dùng nhấn nút Enter sau gõ ký tự ở ô tìm kiếm
    eventHandler(keyCode) {
        if (keyCode.key == "Enter") {
            this.search();
        }
    }
    thaydoiDonVi($event) {
        this.donviChon = $event;
        this.dongMoDropdown = false;
        this.mBuocThucHien.IdDonVi = this.donviChon.id;
        this.mBuocThucHien.TenDonVi = this.donviChon.name;
    }
    thaydoiDonViSMS($event) {
        this.donviChonSMS = $event;
        this.dongMoDropdownSMS = false;
        this.getDSNhanVienTheoCoQuan(this.mCauHinhSMSQuyTrinh);
    }

    GetListCoQuan() {
        this.serviceCoQuan.GetListAll()
            .subscribe(
            (data) => {
                this.mListCoQuan = data;
            },
            er => {
                if (er.status == 401) {
                    this.router.navigate(['./login']);
                }
            });
    }
    GetListMucDoUuTien() {
        this.serviceMucDoUuTien.GetListAll()
            .subscribe(
            (data) => {                
                this.mListMucDoUuTien = data;                
                if(this.mQuyTrinh.NangCap == -1)
                    this.mListMucDoUuTien = data;
                else{
                    this.mListMucDoUuTien = data.filter(f=>f.IdLoaiYeuCau == this.mQuyTrinh.NangCap);
                    if(this.mListMucDoUuTien.length > 0)                    
                        this.mIdMucDoQuyTrinh = this.mListMucDoUuTien[0].Id;
                    else
                        this.mIdMucDoQuyTrinh = 1;
                    this.getListCauHinhSMS();
                }
            },
            er => {
                if (er.status == 401) {
                    this.router.navigate(['./login']);
                }
            });
    }
    GetListDonVi(IdCoQuan: number) {
        this.serviceDonVi.GetTreeListByCoQuan(IdCoQuan)
            .subscribe(
            (data) => {                
                if(data[0] != null){
                    this.mListDonVi = data;
                    if (this.mBuocThucHien.IdDonVi == 0) {
                        this.mBuocThucHien.IdDonVi = data[0].id;
                        this.mBuocThucHien.TenDonVi = data[0].name;
                    }
                }                
            },
            er => {
                if (er.status == 401) {
                    this.router.navigate(['./login']);
                }
            });
    }

    GetListDonViCauHinhSMS(IdCoQuan: number) 
    {
        this.donviChonSMS = { name: '--- Chọn đơn vị ---', id: 0 };
        this.serviceDonVi.GetTreeListByCoQuan(IdCoQuan)
            .subscribe(
            (data) => {
                this.mListDonViCauHinhSMS = data;
            },
            er => {
                if (er.status == 401) {
                    this.router.navigate(['./login']);
                }
            });
    }
    getListNhanVien(item: CauHinhSMSQuyTrinh) {
        this.mCauHinhSMSQuyTrinh = item;
        if (item.Id != 0)
            this.showNhanVien = true;
        else
            this.showNhanVien = false;
        
        this.GetListDonViCauHinhSMS(this.mBuocThucHien.IdCoQuan == 0?this.auth.user.IdCoQuan:this.mBuocThucHien.IdCoQuan);
        this.getDSNhanVienTheoCoQuan(item).then(()=>{
            this.getListNhanVienNhanSMS(item).then(()=>{
                this.getDSNhanVienTheoCoQuanTapDoan();
            });
        });
        
    }
    getDSNhanVienTheoCoQuan(item: CauHinhSMSQuyTrinh):Promise<void>{
        return new Promise<void>(resolve=>{
            var IdCoQuan: number = 0;
            if (this.mBuocThucHien.Id == 0) {
                IdCoQuan = this.mQuyTrinh.IdCoQuan;
            } else {
                IdCoQuan = this.mBuocThucHien.IdCoQuan == 0?this.auth.user.IdCoQuan:this.mBuocThucHien.IdCoQuan;;
            }
            this.serviceCauHinhSMS.getListNhanVienTheoCoQuanQuyTrinhSMS(IdCoQuan, this.donviChonSMS.id, item.Id)
                .subscribe(
                (data) => {
                    this.mListNhanVienQuyTrinh = data.sort(function(a,b){
                        let a1 = a.HoTen.toUpperCase();
                        let b1 = b.HoTen.toUpperCase();
                        return a1.localeCompare(b1,'de',{sensitivity:'base'});
                    });
                    resolve();
                    //console.log(data);
                    $('#lstview1').multiselect();
                },
                er => {
                    if (er.status == 401) {
                        this.router.navigate(['./login']);
                    }
                });
        });
    } 
   
    getListNhanVienNhanSMS(item: CauHinhSMSQuyTrinh):Promise<void>{
        return new Promise<void>(resolve=>{
            this.serviceCauHinhSMS.getListNhanVienNhanSMS(item.Id)
            .subscribe(
            (data) => {
                this.mListNhanVienNhanSMSQuyTrinh = data.sort(function(a,b){
                    let a1 = a.HoTen.toUpperCase();
                    let b1 = a.HoTen.toUpperCase();
                    return a1.localeCompare(b1,'de',{sensitivity:'base'});
                });
                resolve();
                //console.log(data);
                //$('#lstview1').multiselect();
            },
            er => {
                if (er.status == 401) {
                    this.router.navigate(['./login']);
                }
            });
        });
    } 
    
    GetListCongViec() {
        let CV = { page: 1, pagesize: 1000000 };
        this.congviecService.DanhSach_CongViec(CV)
            .subscribe(
            (data) => {
                this.mListCongViec = data;
                console.log(this.mListCongViec);
            },
            er => {
                if (er.status == 401) {
                    this.router.navigate(['./login']);
                }
            });
    }
    editable(item: CauHinhSMSQuyTrinh) {
        item.EditAble = true;
    }
    luuCauHinh(item: CauHinhSMSQuyTrinh) {
        this.saveStatusMessage = "Đang xử lý vui lòng chờ";
        this.saveStatus = false;
        //jQuery("#loader").modal();
        item.IdQuyTrinh = this.mQuyTrinh.Id;
        item.IdBuoc = this.mBuocThucHien.Id;
        item.IdMucDo = this.mIdMucDoQuyTrinh;
        item.Saving = true;
        item.EditAble = false;
        this.serviceCauHinhSMS.Save(item).subscribe(
            (resp) => {
                if (resp.Success) {
                    this.getListCauHinhSMS();
                    
                }
                else {
                    this.saveStatusMessage = "Lỗi khi thêm cấu hình sms cho quy trình " + this.mQuyTrinh.Ten + "! Xin vui lòng thực hiện lại sau";
                    this.saveStatus = false;
                    //jQuery("#loader").modal();
                }
            },
            (er) => {
                if (er.status == 401) {
                    this.router.navigate(['./login']);
                }
                console.log(er);
                this.saveStatusMessage = "Lỗi khi lưu dữ liệu! Xin vui lòng thực hiện lại sau";
                this.saveStatus = false;
            }
        )

    }
    AddCauHinhSMSQuyTrinh() {
        var item: CauHinhSMSQuyTrinh = new CauHinhSMSQuyTrinh();
        item.IdMucDo = 0;
        item.IdBuoc = this.mBuocThucHien.Id;
        item.EditAble = true;
        item.ThuTuNhanSMS = this.mListCauHinhSMSQuyTrinh.length + 1;
        this.mListCauHinhSMSQuyTrinh.push(item);
    }
    DeleteCauHinh(i: number, ds: CauHinhSMSQuyTrinh) {
        this.mListCauHinhSMSQuyTrinh.splice(i, 1);
        if (ds.Id != 0) {
            this.serviceCauHinhSMS.Delete(ds).subscribe(
                (resp) => {
                    if (resp.Success) {
                        this.getListCauHinhSMS();
                        //this.saveStatusMessage = "Thêm cấu hình sms cho quy trình " + this.mQuyTrinh.Ten + " thành công!";
                        //this.saveStatus = true;
                        //jQuery("#loader").modal();
                    }
                    else {
                        this.saveStatusMessage = "Lỗi khi xoá cấu hình sms cho quy trình " + this.mQuyTrinh.Ten + "! Xin vui lòng thực hiện lại sau";
                        this.saveStatus = false;
                        jQuery("#loader").modal();
                    }
                },
                (er) => {
                    if (er.status == 401) {
                        this.router.navigate(['./login']);
                    }
                    console.log(er);
                    this.saveStatusMessage = "Lỗi khi lưu dữ liệu! Xin vui lòng thực hiện lại sau";
                    this.saveStatus = false;
                }
            )
        }
    }
    ResetListCauHinh() {
        this.mListCauHinhSMSQuyTrinh = [];
        this.mListMucDoQuyTrinh = [];
        this.resetNhanVien();
        this.showNhanVien = false;
    }
    luuQuyTrinhMucDo() {
        let listMucDo = [];
        let listEmail = [];
        if (this.mQuyTrinh.Id) {
            this.saveStatusMessage = 'Xin vui lòng đợi trong giây lát !';
            this.saveStatus = false;

            for (let i = 0; i < this.mListMucDoQuyTrinh.length; i++) {
                if (this.mListMucDoQuyTrinh[i].SMS)
                    listMucDo.push(this.mListMucDoQuyTrinh[i].Id)
                if (this.mListMucDoQuyTrinh[i].Email)
                    listEmail.push(this.mListMucDoQuyTrinh[i].Id)
            }
            let mergelist = [];
            mergelist.push(listMucDo);
            mergelist.push(listEmail);
            this.service.saveMucDoQuyTrinh(this.mQuyTrinh.Id, mergelist).subscribe(
                (resp) => {
                    if (resp.Success) {

                        this.saveStatusMessage = " Lưu cấu hình sms/email cho " + this.mQuyTrinh.Ten + " thành công!";
                        this.saveStatus = true;
                        this.ShowAlert(this.saveStatusMessage, "success");
                        this.ResetListCauHinh();
                    }
                    else {
                        this.saveStatusMessage = "Lỗi khi lưu cấu hình " + this.mQuyTrinh.Ten + "! Xin vui lòng thực hiện lại sau";
                        this.saveStatus = false;
                        this.ShowAlert(this.saveStatusMessage, "error");
                    }
                },
                (er) => {
                    if (er.status == 401) {
                        this.router.navigate(['./login']);
                    }
                    console.log(er);
                    this.saveStatusMessage = "Lỗi khi lưu dữ liệu! Xin vui lòng thực hiện lại sau";
                    this.saveStatus = false;
                }
            )
        }
    }
    getItemQT(item: QuyTrinhXuLyThietBi) {
        this.mQuyTrinh = item;
        this.Load_dsAnhQuyTrinh(item.Id);
        this.serviceSanPham.GetTreeListGroup()
            .subscribe(
            (data) => {
                this.dmThietBiTreeData = data;

                this.thietbiChonGlobal.id = item.IdNhom;
                this.thietbiChonGlobal.name = item.TenNhom;
                this.mTB.TenThietBi = item.Ten;

                $("#loader").modal('hide');
                $("#myModalAdd").modal();
                this.HideAlert("error", true);
            },
            er => {
                if (er.status == 401) {
                    this.router.navigate(['./login']);
                }
                this.saveStatusMessage = "Có lỗi khi load cây thiết bị !";
                this.saveStatus = true;
            });

    }
    getItemDeleteQT(item: QuyTrinhXuLyThietBi) {
        this.mQuyTrinh = item;
        this.service.CheckYeuCau(item.Id).subscribe((resp) => {
            if (resp.flag == 1) {
                $("#modalConfirmXoaQT").modal();
            }
            else {
                this.saveStatusMessage = "Đang phát sinh yêu cầu tại quy trình! Vui lòng xử lý hoặc kiểm tra lại!";
                jQuery("#ThongBao").modal({ backdrop: 'static', keyboard: true });
            }
        },
            (er) => {
                $("#modalConfirmXoaQT").modal();
            });
    }
    getItemApDungQT(item: QuyTrinhXuLyThietBi) {
        this.mQuyTrinh = item;
        this.service.CheckYeuCau(item.Id).subscribe((resp) => {
            if (resp.flag == 1) {
                if (this.mListBuocThucHien.length == 0) {
                    this.saveStatusMessage = "Chưa có bước thực hiện trong quy trình";
                    jQuery("#ThongBao").modal({ backdrop: 'static', keyboard: true });
                }
                else
                    jQuery("#modalConfirmApDungQT").modal();
            }
            else {
                this.saveStatusMessage = "Đang phát sinh yêu cầu tại quy trình! Vui lòng xử lý hoặc kiểm tra lại!";
                jQuery("#ThongBao").modal({ backdrop: 'static', keyboard: true });
            }
        },
            (er) => {
                if (this.mListBuocThucHien.length == 0) {
                    this.saveStatusMessage = "Chưa có bước thực hiện trong quy trình";
                    jQuery("#ThongBao").modal({ backdrop: 'static', keyboard: true });
                }
                else
                    jQuery("#modalConfirmApDungQT").modal();
            });
    }
    createRange(number) {
        let items = [];
        for (var i = 1; i <= number; i++) {
            items.push(i);
        }
        return items;
    }
    Reset() {
        this.fileListDisplay=[];
        this.divGhiChu.nativeElement.hidden = true;
        this.mQuyTrinh = new QuyTrinhXuLyThietBi();
        this.mBuocThucHien = new BuocThucHien();
        this.mCauHinhSMSQuyTrinh = new CauHinhSMSQuyTrinh();
        this.donviChonSMS = { name: '--- Chọn đơn vị ---', id: 0 };
        this.showNhanVien = false;
        this.divCongViec.nativeElement.hidden = true;
        //this.divCoQuan.nativeElement.hidden = true;
    }
    getItemCoppyQT(item: QuyTrinhXuLyThietBi) {
        this.divMaQuyTrinh.nativeElement.hidden = true;
        this.mQuyTrinh = item;
        this.service.GetListAll().subscribe(
            (data) => {
                this.mListQuyTrinhIndex = data;
            });
        if (this.mListBuocThucHien.length > 0) {
            jQuery("#modalConfirmCoppyQT").modal();
        }
        else
            jQuery("#modalCoppyQT").modal();
    }
    SaoChep() {
        if (this.IdQuyTrinhCoppy == this.mQuyTrinh.Id) {
            this.IdQuyTrinhCoppy = 0;
            this.saveStatusMessage = "Bạn đang coppy quy trình này cho chính nó";
            jQuery("#ThongBao").modal({ backdrop: 'static', keyboard: true });
        } else if (this.IdQuyTrinhCoppy != 0) {
            jQuery("#modalCoppyQT").modal('hide');
            this.divMaQuyTrinh.nativeElement.hidden = true;
            this.saveStatusMessage = 'Xin vui lòng đợi trong giây lát !';
            this.service.Coppy(this.IdQuyTrinhCoppy, this.mQuyTrinh.Id).subscribe(
                (resp) => {
                    if (resp.flag == 1) {
                        //this.GetList();
                        this.GetListQuyTrinh(this.pagingQuyTrinh);
                        this.saveStatusMessage = "Sao chép thành công!";
                        this.saveStatus = true;
                        jQuery("#loader").modal();
                    }
                    else {
                        this.GetListQuyTrinh(this.pagingQuyTrinh);
                        this.saveStatusMessage = "Quy trình chưa tồn tại hoặc đã bị xoá";
                        jQuery("#ThongBao").modal({ backdrop: 'static', keyboard: true });
                        //this.mQuyTrinh.TrangThaiApDung = 0;
                    }
                    this.IdQuyTrinhCoppy = undefined;
                },
                (er) => {
                    if (er.status == 401) {
                        this.router.navigate(['./login']);
                    }
                    console.log(er);
                    this.saveStatusMessage = "Quy trình chưa tồn tại hoặc đã bị xoá";
                    jQuery("#ThongBao").modal({ backdrop: 'static', keyboard: true });
                }
            )

        } else {
            this.divMaQuyTrinh.nativeElement.hidden = false;
        }
    }
    changeCongViec() {
        this.divCongViec.nativeElement.hidden = true;
    }
    changeCoQuan() {
        //this.divCoQuan.nativeElement.hidden = true;
    }
    changeMaQuyTrinh() {
        this.divMaQuyTrinh.nativeElement.hidden = true;
    }
    onSelectCoQuan(value) {
        this.mBuocThucHien.IdDonVi = 0;
        this.mBuocThucHien.TenDonVi = '';
        this.GetListDonVi(value);
    }

    getListBuoc(item: QuyTrinhXuLyThietBi) {
        this.mQuyTrinh = item;
        this.ShowAlert("Đang load danh sách bước xử lý ...", "status");
        this.serviceBuocThucHien.GetList(this.mQuyTrinh.Id)
            .subscribe(
            (data) => {
                this.HideAlert("status");
                this.mListBuocThucHien = data;
            },
            er => {
                if (er.status == 401) {
                    this.router.navigate(['./login']);
                }
            });
    }
    changeMucDoQuyTrinh() {
        this.getListCauHinhSMS();
    }
    
    setCauHinhSMSQuyTrinh(item: QuyTrinhXuLyThietBi) {
        this.mQuyTrinh = item;
        //this.mBuocThucHien = new BuocThucHien();
        this.getListCauHinhSMS();
    }
    getListMucDoQuyTrinh(item: QuyTrinhXuLyThietBi) {
        this.mListMucDoQuyTrinh = [];
        this.service.GetListMucDo(item.Id)
            .subscribe(
            (data) => {
                this.mListMucDoQuyTrinh = data;
                console.log(this.mListMucDoQuyTrinh);
            },
            er => {
                if (er.status == 401) {
                    this.router.navigate(['./login']);
                }
            });
    }
    setCauHinhSMSBuoc(item: BuocThucHien) {
        this.mIdMucDoQuyTrinh = 1;
        this.mBuocThucHien = item;
        this.GetListMucDoUuTien();
        //this.getListCauHinhSMS();
    }
    getListCauHinhSMS() {
        this.TTSMS = false;
        //this.mListCauHinhSMSQuyTrinh = [];
        //console.log(this.mBuocThucHien);
        
        this.serviceCauHinhSMS.GetList(this.mQuyTrinh.Id, this.mIdMucDoQuyTrinh, this.mBuocThucHien.Id)
            .subscribe(
            (data) => {
                this.mListCauHinhSMSQuyTrinh = data;
                jQuery("#loader").modal('hide');
            },
            er => {
                if (er.status == 401) {
                    this.router.navigate(['./login']);
                }
            });
        //this.GetListDonViCauHinhSMS(this.mQuyTrinh.IdCoQuan);
    }
    addNhanVienNhanSMS() {
        this.thongBaoLuuNhanVien = false;
        this.savingNhanVien = true;
        let listDaiBieu = [];
        $("#lstview1_to option").each(function () {
            listDaiBieu.push($(this).val());
        });

        this.serviceCauHinhSMS.addNhanVien(this.mCauHinhSMSQuyTrinh.Id, listDaiBieu)
            .subscribe((data) => {
                listDaiBieu.length = 0;
                this.resetNhanVien();
                this.getListCauHinhSMS();
                this.savingNhanVien = false;
            },
            error => {
            });
    }
    resetNhanVien() {
        this.donviChonSMS = { name: '--- Chọn đơn vị ---', id: 0 };
        this.showNhanVien = false;
        this.thongBaoLuuNhanVien = false;
        this.mListNhanVienNhanSMSQuyTrinh = [];
        this.mListNhanVienQuyTrinh = [];
    }
    DeleteBuoc(item: BuocThucHien) {
        this.saveStatusMessage = 'Xin vui lòng đợi trong giây lát !';
        this.saveStatus = false;
        jQuery("#loader").modal();
        this.serviceBuocThucHien.Delete(item).subscribe(
            (resp) => {
                if (resp.Success) {
                    //this.GetList();
                    this.getListBuoc(this.mQuyTrinh);
                    this.saveStatusMessage = "Xóa bước thành công!";
                    this.saveStatus = true;
                    jQuery("#loader").modal();
                    this.mBuocThucHien = new BuocThucHien();
                }
                else {
                    this.saveStatusMessage = "Lỗi khi xóa dữ liệu! Xin vui lòng thực hiện lại sau";
                    this.saveStatus = false;
                }
            },
            (er) => {
                if (er.status == 401) {
                    this.router.navigate(['./login']);
                }
                console.log(er);
                this.saveStatusMessage = "Lỗi khi xóa dữ liệu! Xin vui lòng thực hiện lại sau";
                this.saveStatus = false;
            }
        )

    }
    selectItemBuoc(item: BuocThucHien) {
        this.mBuocThucHien = item;
    }
    getitemBuoc(item: BuocThucHien) {
        this.mBuocThucHien = item;
        this.GetListDonVi(this.mBuocThucHien.IdCoQuan);
        $("#addModal").modal();
        this.HideAlert("error", true);


    }
    setItemBuoc(item: BuocThucHien) {
        this.service.CheckYeuCau(this.mQuyTrinh.Id).subscribe((resp) => {
            if (resp.flag == 1) {
                this.mBuocThucHien = item;
                $("#delModal").modal();
            }
            else {
                this.HideAlert("status");
                this.ShowAlert("Đang phát sinh yêu cầu tại quy trình! Vui lòng xử lý hoặc kiểm tra lại!", "error");
            }
        },
            (er) => {
                $("#delModal").modal();
            });

    }
    getitemCauHinhSMSQuyTrinh(item: CauHinhSMSQuyTrinh) {
        this.mCauHinhSMSQuyTrinh = item;
    }
    ThemBuocMoi() {
        this.service.CheckYeuCau(this.mQuyTrinh.Id).subscribe((resp) => {
            if (resp.flag == 1) {
                if (this.mBuocThucHien.STT == 0)
                    this.mBuocThucHien.STT = this.mListBuocThucHien.length + 1;
                $("#addModal").modal();
            }
            else {
                this.saveStatusMessage = "Đang phát sinh yêu cầu tại quy trình! Vui lòng xử lý hoặc kiểm tra lại!";
                jQuery("#ThongBao").modal({ backdrop: 'static', keyboard: true });
            }
        },
            (er) => {
                if (this.mBuocThucHien.STT == 0)
                    this.mBuocThucHien.STT = this.mListBuocThucHien.length + 1;
                $("#addModal").modal();
            });


    }
    XoaQuyTrinh() {
        this.ShowAlert("Xin vui lòng đợi trong giây lát !", "status", true);
        this.service.Delete(this.mQuyTrinh).subscribe(
            (resp) => {
                if (resp.Success) {
                    //this.GetList();
                    this.GetListQuyTrinh(this.pagingQuyTrinh);
                    this.HideAlert("status", true);
                    this.ShowAlert("Xoá quy trình thành công!", "success");
                }
                else {
                    this.HideAlert("status", true);
                    this.ShowAlert("Có lỗi khi xoá quy trình! Xin vui lòng thử lại", "error", true);
                }
            },
            (er) => {
                if (er.status == 401) {
                    this.router.navigate(['./login']);
                }
                this.HideAlert("status", true);
                this.ShowAlert("Có lỗi khi xoá quy trình! Xin vui lòng thử lại", "error", true);
            }
        )
        this.Reset();
    }
    ApDung() {
        this.ShowAlert("Xin vui lòng đợi trong giây lát !", "status");
        //jQuery("#loader").modal();
        if (this.mQuyTrinh.TrangThaiApDung) {
            this.service.UnApply(this.mQuyTrinh).subscribe(
                (resp) => {
                    if (resp.flag == 1) {
                        //this.GetList();
                        this.GetListQuyTrinh(this.pagingQuyTrinh);
                        this.HideAlert("status");
                        this.ShowAlert("Huỷ áp dụng " + this.mQuyTrinh.Ten + " thành công!", "success");
                    }
                    else {
                        this.HideAlert("status");
                        this.ShowAlert("Huỷ áp dụng " + this.mQuyTrinh.Ten + "chưa thành công!", "error");
                        this.mQuyTrinh.TrangThaiApDung = 1;
                    }
                },
                (er) => {
                    if (er.status == 401) {
                        this.router.navigate(['./login']);
                    }
                    console.log(er);
                    this.HideAlert("status");
                    this.ShowAlert("Huỷ áp dụng " + this.mQuyTrinh.Ten + "chưa thành công!", "error");
                }
            )
        } else {
            this.service.Apply(this.mQuyTrinh).subscribe(
                (resp) => {
                    if (resp.flag == 1) {
                        //this.GetList();
                        this.GetListQuyTrinh(this.pagingQuyTrinh);
                        this.HideAlert("status");
                        this.ShowAlert("Áp dụng " + this.mQuyTrinh.Ten + " thành công!", "success");
                    }
                    else {
                        this.GetListQuyTrinh(this.pagingQuyTrinh);
                        this.saveStatusMessage = "Đã có quy trình được áp dụng cho sản phẩm này";
                        this.HideAlert("status");
                        this.ShowAlert("Đã có quy trình được áp dụng cho sản phẩm này", "error");
                        //this.mQuyTrinh.TrangThaiApDung = 0;
                    }
                },
                (er) => {
                    if (er.status == 401) {
                        this.router.navigate(['./login']);
                    }
                    this.HideAlert("status");
                    this.ShowAlert("Áp dụng " + this.mQuyTrinh.Ten + "chưa thành công!", "error");
                }
            )
        }
        this.Reset();
    }
    KeyUpTen() {
        this.divGhiChu.nativeElement.hidden = true;
    }
    LuuBuoc() {
        console.log(this.mBuocThucHien);
        this.service.CheckYeuCau(this.mQuyTrinh.Id).subscribe((resp) => {
            this.ShowAlert("Xin vui lòng đợi trong giây lát !", "status", true);
            if (resp.flag == 1) {
                if (this.mBuocThucHien.IdTrangThai >= 99) {
                    this.mBuocThucHien.IdCoQuan = 0;
                    this.mBuocThucHien.IdDonVi = 0;
                }
                if (this.mBuocThucHien.IdCongViec && this.mBuocThucHien.IdTrangThai > 0) {
                    this.mBuocThucHien.ThoiGianXuLy = this.mBuocThucHien.Ngay * 1440 + this.mBuocThucHien.Gio * 60 + this.mBuocThucHien.Phut

                    this.mBuocThucHien.IdQuyTrinh = this.mQuyTrinh.Id;
                    this.saveStatusMessage = 'Xin vui lòng đợi trong giây lát !';
                    //jQuery("#loader").modal();
                    this.serviceBuocThucHien.Save(this.mBuocThucHien).subscribe(
                        (resp) => {
                            if (resp.Success) {
                                this.getListBuoc(this.mQuyTrinh);
                                this.HideAlert("status", true);
                                this.ShowAlert("Thêm bước thực hiện cho quy trình " + this.mQuyTrinh.Ten + " thành công!", "success");

                                //jQuery("#loader").modal();
                                jQuery("#addModal").modal('hide');

                            }
                            else {
                                //this.saveStatusMessage = "Lỗi khi thêm bước thực hiện cho quy trình " + this.mQuyTrinh.Ten + "! Xin vui lòng thực hiện lại sau";
                                //this.saveStatus = false;
                                this.HideAlert("status", true);
                                this.ShowAlert("Lỗi khi thêm bước thực hiện cho quy trình " + this.mQuyTrinh.Ten + "! Xin vui lòng thực hiện lại sau", "error", true);
                            }
                        },
                        (er) => {
                            if (er.status == 401) {
                                this.router.navigate(['./login']);
                            }
                            this.HideAlert("status", true);
                            this.ShowAlert("Lỗi khi thêm bước thực hiện cho quy trình " + this.mQuyTrinh.Ten + "! Xin vui lòng thực hiện lại sau", "error", true);
                        }
                    )

                    this.mBuocThucHien = new BuocThucHien();
                } else {
                    if (!this.mBuocThucHien.IdCongViec)
                        this.divCongViec.nativeElement.hidden = false;
                    if (!this.mBuocThucHien.IdCoQuan)
                        //this.divCoQuan.nativeElement.hidden = false;
                        if (!this.mBuocThucHien.IdTrangThai)
                            this.divTrangThai.nativeElement.hidden = false;
                }
            }
            else {
                //this.saveStatusMessage = "Đang phát sinh yêu cầu tại quy trình! Vui lòng xử lý hoặc kiểm tra lại!";
                //jQuery("#ThongBao").modal({ backdrop: 'static', keyboard: true });
                this.HideAlert("status", true);
                this.ShowAlert("Đang phát sinh yêu cầu tại quy trình! Vui lòng xử lý hoặc kiểm tra lại!", "error", true);
            }
        },
            (er) => {

                if ((this.mBuocThucHien.IdCongViec && this.mBuocThucHien.IdCoQuan) || (this.mBuocThucHien.IdCongViec && this.mBuocThucHien.IdNhomCoQuan)) {
                    this.mBuocThucHien.ThoiGianXuLy = this.mBuocThucHien.Ngay * 1440 + this.mBuocThucHien.Gio * 60 + this.mBuocThucHien.Phut
                    jQuery("#addModal").modal('hide');
                    this.mBuocThucHien.IdQuyTrinh = this.mQuyTrinh.Id;
                    this.saveStatusMessage = 'Xin vui lòng đợi trong giây lát !';
                    jQuery("#loader").modal();
                    this.serviceBuocThucHien.Save(this.mBuocThucHien).subscribe(
                        (resp) => {
                            if (resp.Success) {
                                this.getListBuoc(this.mQuyTrinh);
                                this.saveStatusMessage = "Thêm bước thực hiện cho quy trình " + this.mQuyTrinh.Ten + " thành công!";
                                this.saveStatus = true;
                                jQuery("#loader").modal();

                            }
                            else {
                                this.saveStatusMessage = "Lỗi khi thêm bước thực hiện cho quy trình " + this.mQuyTrinh.Ten + "! Xin vui lòng thực hiện lại sau";
                                this.saveStatus = false;
                            }
                        },
                        (er) => {
                            if (er.status == 401) {
                                this.router.navigate(['./login']);
                            }
                            console.log(er);
                            this.saveStatusMessage = "Lỗi khi lưu dữ liệu! Xin vui lòng thực hiện lại sau";
                            this.saveStatus = false;
                        }
                    )

                    this.mBuocThucHien = new BuocThucHien();
                } else {
                    if (!this.mBuocThucHien.IdCongViec)
                        this.divCongViec.nativeElement.hidden = false;
                    if (!this.mBuocThucHien.IdCoQuan)
                        //this.divCoQuan.nativeElement.hidden = false;
                        if (!this.mBuocThucHien.IdTrangThai)
                            this.divTrangThai.nativeElement.hidden = false;
                }
            });


    }
    Save() {
        if (this.mQuyTrinh.Id == 0) {
            if (this.mQuyTrinh.IdThietBi) {
                this.ShowAlert("Xin vui lòng đợi trong giây lát !", "status", true);
                this.service.Save(this.mQuyTrinh).subscribe(
                    (resp) => {
                        if (resp.Success) {
                            jQuery("#myModalAdd").modal('hide');
                            //this.GetList();
                            this.idLoaiQuyTrinhSearch = this.mQuyTrinh.TrangThaiApDung;
                            this.GetListQuyTrinh(this.pagingQuyTrinh, false);

                            this.HideAlert("status", true);
                            this.ShowAlert(this.changeAddUpdate + " " + this.mQuyTrinh.Ten + " thành công!", "success");

                            this.Luu_anhquytrinh(resp.N);
                        }
                        else {
                            this.HideAlert("status", true);
                            this.ShowAlert("Lỗi khi " + this.changeAddUpdate + " " + this.mQuyTrinh.Ten + "", "error", true);

                        }
                    },
                    (er) => {
                        if (er.status == 401) {
                            this.router.navigate(['./login']);
                        }
                        this.HideAlert("status", true);
                        this.ShowAlert("Lỗi khi " + this.changeAddUpdate + " " + this.mQuyTrinh.Ten + "", "error", true);

                    }
                )
            }
        } else {
            this.service.CheckYeuCau(this.mQuyTrinh.Id).subscribe((resp) => {
                if (resp.flag == 1) {
                    if (this.mQuyTrinh.IdThietBi) {
                        this.ShowAlert("Xin vui lòng đợi trong giây lát !", "status", true);
                        this.service.Save(this.mQuyTrinh).subscribe(
                            (resp) => {
                                if (resp.Success) {
                                    jQuery("#myModalAdd").modal('hide');
                                    //this.GetList();
                                    this.GetListQuyTrinh(this.pagingQuyTrinh, false);
                                    this.HideAlert("status", true);
                                    this.ShowAlert(this.changeAddUpdate + " " + this.mQuyTrinh.Ten + " thành công!", "success");
                                    this.Luu_anhquytrinh(resp.N);
                                    this.Reset();
                                }
                                else {
                                    this.HideAlert("status", true);
                                    this.ShowAlert("Lỗi khi " + this.changeAddUpdate + " " + this.mQuyTrinh.Ten, "error");

                                }
                            },
                            (er) => {
                                if (er.status == 401) {
                                    this.router.navigate(['./login']);
                                }
                                this.HideAlert("status", true);
                                this.ShowAlert("Lỗi khi " + this.changeAddUpdate + " " + this.mQuyTrinh.Ten, "error");

                            }
                        )
                    }
                }
                else {
                    this.HideAlert("status", true);
                    this.ShowAlert("Đang phát sinh yêu cầu tại quy trình! Vui lòng xử lý hoặc kiểm tra lại!", "error");
                }
            },
                (er) => {
                    if (this.mQuyTrinh.IdThietBi) {
                        this.saveStatusMessage = 'Xin vui lòng đợi trong giây lát !';
                        jQuery("#loader").modal();
                        this.service.Save(this.mQuyTrinh).subscribe(
                            (resp) => {
                                if (resp.Success) {
                                    jQuery("#myModalAdd").modal('hide');
                                    //this.GetList();
                                    this.GetListQuyTrinh(this.pagingQuyTrinh, false);
                                    this.saveStatusMessage = this.changeAddUpdate + " " + this.mQuyTrinh.Ten + " thành công!";
                                    this.saveStatus = true;
                                    jQuery("#loader").modal();
                                    this.Reset();
                                }
                                else {
                                    this.saveStatusMessage = "Lỗi khi " + this.changeAddUpdate + " " + this.mQuyTrinh.Ten + "! Xin vui lòng thực hiện lại sau";
                                    this.saveStatus = false;
                                }
                            },
                            (er) => {
                                if (er.status == 401) {
                                    this.router.navigate(['./login']);
                                }
                                console.log(er);
                                this.saveStatusMessage = "Lỗi khi lưu dữ liệu! Xin vui lòng thực hiện lại sau";
                                this.saveStatus = false;
                            }
                        )
                    }
                });
        }


    }
    onDragStart(event, data: BuocThucHien) {
        event.dataTransfer.setData('Id', data.Id);
        event.dataTransfer.setData('STT', data.STT);
    }

    onDrop(event, data: BuocThucHien) {

        let id = parseInt(event.dataTransfer.getData('Id'));
        let sttthuchien = parseInt(event.dataTransfer.getData('STT'));
        event.preventDefault();
        /*
        for (let i = 0; i < this.mListBuocThucHien.length; i++) {
            if (this.mListBuocThucHien[i].Id == id) {
                //let a = sttthuchien
                this.mListBuocThucHien[i].STT = data.STT;
            }
        }
        for (let i = 0; i < this.mListBuocThucHien.length; i++) {
            if (this.mListBuocThucHien[i].Id == data.Id) {
                //let a = sttthuchien
                this.mListBuocThucHien[i].STT = sttthuchien;
            }
        }
        */
        let STT = 0;
        for (let i = 0; i < this.mListBuocThucHien.length; i++) {
            if (this.mListBuocThucHien[i].Id == id) {
                //let a = sttthuchien
                this.mListBuocThucHien[i].STT = data.STT;
                STT = data.STT;
                break;
            }
        }
        this.mListBuocThucHien.sort(function (a, b) {
            return a.STT - b.STT;
        });
        if(sttthuchien >= data.STT){                                            
            for (let i = 0; i < this.mListBuocThucHien.length; i++) {
                if (this.mListBuocThucHien[i].Id !== id && this.mListBuocThucHien[i].STT >= data.STT) {
                    //let a = sttthuchien
                    STT = STT + 1;
                    this.mListBuocThucHien[i].STT = STT;                
                }
            }
        }else{
            let stt = 0;
            for (let i = 0; i < this.mListBuocThucHien.length; i++) {
                if (this.mListBuocThucHien[i].Id !== id && this.mListBuocThucHien[i].STT <= data.STT) {
                    stt = stt + 1;                    
                    this.mListBuocThucHien[i].STT = stt;                
                }
            }
        }

        STT = 0;
        

        this.mListBuocThucHien.sort(function (a, b) {
            return a.STT - b.STT;
        });
        this.TT = true;

    }
    onDragStartSMS(event, data: CauHinhSMSQuyTrinh) {
        event.dataTransfer.setData('Id', data.Id);
        event.dataTransfer.setData('ThuTuNhanSMS', data.ThuTuNhanSMS);
    }

    onDropSMS(event, data: CauHinhSMSQuyTrinh) {

        var id = event.dataTransfer.getData('Id');
        var sttthuchien = event.dataTransfer.getData('ThuTuNhanSMS');
        event.preventDefault();
        for (let i = 0; i < this.mListCauHinhSMSQuyTrinh.length; i++) {
            if (this.mListCauHinhSMSQuyTrinh[i].Id == id) {
                //let a = sttthuchien
                this.mListCauHinhSMSQuyTrinh[i].ThuTuNhanSMS = data.ThuTuNhanSMS;
            }
        }
        for (let i = 0; i < this.mListCauHinhSMSQuyTrinh.length; i++) {
            if (this.mListCauHinhSMSQuyTrinh[i].Id == data.Id) {
                //let a = sttthuchien
                this.mListCauHinhSMSQuyTrinh[i].ThuTuNhanSMS = sttthuchien;
            }
        }
        this.mListCauHinhSMSQuyTrinh.sort(function (a, b) {
            return a.ThuTuNhanSMS - b.ThuTuNhanSMS;
        });
        console.log("list 1");
        console.log(this.mListCauHinhSMSQuyTrinh);
        console.log("list 2");
        console.log(this.mListCauHinhSMSQuyTrinhTemp);

        this.TTSMS = true;

    }
    SapXep() {
        let arr = new Array();
        for (let i = 0; i < this.mListBuocThucHien.length; i++) {
            if (this.mListBuocThucHien[i] != this.mListBuocThucHienTemp[i]) {
                let item = {
                    Id: this.mListBuocThucHien[i].Id,
                    STT: this.mListBuocThucHien[i].STT
                };
                arr.push(item);
            }
        }
        this.serviceBuocThucHien.CapNhatSTT(arr)
            .subscribe((resp) => {
                if (resp.Success) {
                    this.getListBuoc(this.mQuyTrinh);
                    this.saveStatusMessage = "Lưu thành công!";
                    jQuery("#ThongBao").modal({ backdrop: 'static', keyboard: true });
                }
                else {
                    this.getListBuoc(this.mQuyTrinh);
                    this.saveStatusMessage = "Lỗi khi lưu dữ liệu! Xin vui lòng thực hiện lại sau";
                    jQuery("#ThongBao").modal({ backdrop: 'static', keyboard: true });
                }
            },
            (er) => {
                if (er.status == 401) {
                    this.router.navigate(['./login']);
                }
                console.log(er);
                this.getListBuoc(this.mQuyTrinh);
                this.saveStatusMessage = "Lỗi khi lưu dữ liệu! Xin vui lòng thực hiện lại sau";
                jQuery("#ThongBao").modal({ backdrop: 'static', keyboard: true });
            });
        this.TT = false;
    }
    SapXepSMS() {
        let arr = new Array();
        for (let i = 0; i < this.mListCauHinhSMSQuyTrinh.length; i++) {
            if (this.mListCauHinhSMSQuyTrinh[i] != this.mListCauHinhSMSQuyTrinhTemp[i]) {
                let item = {
                    Id: this.mListCauHinhSMSQuyTrinh[i].Id,
                    ThuTuNhanSMS: this.mListCauHinhSMSQuyTrinh[i].ThuTuNhanSMS
                };
                arr.push(item);
            }
        }
        this.serviceCauHinhSMS.CapNhatSTT(arr)
            .subscribe((resp) => {
                if (resp.Success) {
                    this.getListBuoc(this.mQuyTrinh);
                    this.saveStatusMessage = "Lưu thành công!";
                    jQuery("#ThongBao").modal({ backdrop: 'static', keyboard: true });
                }
                else {
                    this.getListBuoc(this.mQuyTrinh);
                    this.saveStatusMessage = "Lỗi khi lưu dữ liệu! Xin vui lòng thực hiện lại sau";
                    jQuery("#ThongBao").modal({ backdrop: 'static', keyboard: true });
                }
            },
            (er) => {
                if (er.status == 401) {
                    this.router.navigate(['./login']);
                }
                console.log(er);
                this.getListBuoc(this.mQuyTrinh);
                this.saveStatusMessage = "Lỗi khi lưu dữ liệu! Xin vui lòng thực hiện lại sau";
                jQuery("#ThongBao").modal({ backdrop: 'static', keyboard: true });
            });
        this.TTSMS = false;
    }

    HuySapXep() {
        this.getListBuoc(this.mQuyTrinh);
        this.mListBuocThucHien = this.mListBuocThucHienTemp;
        this.TT = false;
    }
    HuySapXepSMS() {
        this.mListCauHinhSMSQuyTrinh = this.mListCauHinhSMSQuyTrinhTemp;
        this.TTSMS = false;
    }
    allowDrop(event) {
        event.preventDefault();
    }
    allowDropSMS(event) {
        event.preventDefault();
    }
    //123
    setCauHinhEmailBuoc(item: BuocThucHien) {
        this.mIdMucDoQuyTrinh = 1;
        this.GetListMucDoUuTien();
        this.mBuocThucHien = item;
        
        this.getDSNhanVienTheoCoQuanEmail(this.mBuocThucHien).then(()=>{
            this.getListNhanVienNhanEmail(this.mBuocThucHien).then(()=>{
                this.getDSNhanVienTheoCoQuanTapDoan();
            });
        });    
        this.GetListDonViCauHinhSMS(this.mBuocThucHien.IdCoQuan== 0?this.auth.user.IdCoQuan:this.mBuocThucHien.IdCoQuan);    
    }
    thaydoiDonViEmail($event) {
        this.donviChonSMS = $event;
        this.dongMoDropdownSMS = false;
        this.getDSNhanVienTheoCoQuanEmail(this.mBuocThucHien);
    }
    getDSNhanVienTheoCoQuanTapDoan(){
        let user = this.auth.user;
        if(user.TaiKhoan == "admin.vnpt"){
            this.serviceNV.GetList(1,300,"",user.IdDonVi).subscribe(
                resp=>{
                    let ds=[];
                    resp.forEach(fa=>{
                        let flag=false;
                        this.mListNhanVienNhanSMSQuyTrinh.forEach(fae=>{
                            if(fa.Id == fae.Id){
                                flag=true;
                                return;
                            }
                        });
                        if(!flag){
                            let item = {
                                Id:fa.Id,
                                HoTen:fa.HoTen,
                                TenChucVu:fa.DienThoai
                            };
                            ds.push(item);
                        }
                    });
                    this.mListNhanVienQuyTrinh = this.mListNhanVienQuyTrinh.concat(ds).sort(function(a,b){
                        let a1 = a.HoTen.toUpperCase();
                        let b1 = b.HoTen.toUpperCase();
                        return (a1.localeCompare(b1,'de', { sensitivity: 'base' }));
                    });
                }
            )
        }
    }
    getDSNhanVienTheoCoQuanEmail(item: BuocThucHien):Promise<void>{
        return new Promise<void>(resolve=>{
            var IdCoQuan: number = 0;
            if (this.mBuocThucHien.Id == 0) {
                IdCoQuan = this.mQuyTrinh.IdCoQuan;
            } else {
                IdCoQuan = this.mBuocThucHien.IdCoQuan == 0?this.auth.user.IdCoQuan:this.mBuocThucHien.IdCoQuan;
            }
            //this.serviceCauHinhEmail.GetListNhanVienTheoCoQuanQuyTrinhEmail(IdCoQuan, this.donviChonSMS.id, item.Id)
            this.serviceCauHinhEmail.GetListNhanVienTheoCoQuanQuyTrinhEmailMD(IdCoQuan, this.donviChonSMS.id, item.Id, this.mIdMucDoQuyTrinh)
                .subscribe(
                (data) => {
                    this.mListNhanVienQuyTrinh = data.sort(function(a,b){
                        let a1 = a.HoTen.toUpperCase();
                        let b1 = b.HoTen.toUpperCase();
                        return (a1.localeCompare(b1,'de', { sensitivity: 'base' }));
                    });
                    resolve();
                    $('#lstviewEmail').multiselect();
                },
                er => {
                    if (er.status == 401) {
                        this.router.navigate(['./login']);
                    }
                });
        });
    }  
    changeMucDoQuyTrinhEMAIL(){                
        this.getDSNhanVienTheoCoQuanEmail(this.mBuocThucHien).then(()=>{
            this.getListNhanVienNhanEmail(this.mBuocThucHien).then(()=>{
                this.getDSNhanVienTheoCoQuanTapDoan();
            });
        });
    }

    getListNhanVienNhanEmail(item: BuocThucHien):Promise<void>{
        return new Promise<void>(resolve=>{
            this.serviceCauHinhEmail.GetListNhanVienNhanEmailMD(item.Id, this.mIdMucDoQuyTrinh)
            .subscribe(
            (data) => {
                this.mListNhanVienNhanSMSQuyTrinh = data.sort(function(a,b){
                    let a1 = a.HoTen.toUpperCase();
                    let b1 = b.HoTen.toUpperCase();
                    return (a1.localeCompare(b1,'de', { sensitivity: 'base' }));
                });;
                
                resolve();
                //$('#lstview1').multiselect();
                //$('#lstviewEmail').multiselect();
            },
            er => {
                if (er.status == 401) {
                    this.router.navigate(['./login']);
                }
            });
        });
    }     
    addNhanVienNhanEmail() {
        this.thongBaoLuuNhanVien = false;
        this.savingNhanVien = true;
        let listDaiBieu = [];
        $("#lstviewEmail_to option").each(function () {
            listDaiBieu.push($(this).val());
        });
        /*
        this.serviceCauHinhEmail.addNhanVien(this.mBuocThucHien.Id, listDaiBieu)
            .subscribe((data) => {
                listDaiBieu.length = 0;
                this.resetNhanVien();
                this.setCauHinhEmailBuoc(this.mBuocThucHien);
                this.savingNhanVien = false;
                this.getListBuoc(this.mQuyTrinh);
                $("#myModalListEmail").modal("hide");
            },
            error => {
            });
        */       
       this.serviceCauHinhEmail.addNhanVienEmail(this.mBuocThucHien.Id, this.mIdMucDoQuyTrinh, listDaiBieu)
            .subscribe((data) => {
                listDaiBieu.length = 0;
                this.resetNhanVien();
                this.setCauHinhEmailBuoc(this.mBuocThucHien);
                this.savingNhanVien = false;
                this.getListBuoc(this.mQuyTrinh);
                $("#myModalListEmail").modal("hide");
            },
            error => {
            });
    }
    getListTree() {
        this.saveStatusMessage = 'Đang load cây thiết bị ...';
        this.saveStatus = false;
        $("#loader").modal();
        this.GetListChild(1);
        this.GetListLoaiThietBi();
        this.serviceSanPham.GetTreeListGroup()
            .subscribe(
            (data) => {
                this.dmThietBiTreeData = data;
                $("#loader").modal('hide');
                $("#myModalListThietBi").modal();
            },
            er => {
                if (er.status == 401) {
                    this.router.navigate(['./login']);
                }
                this.saveStatusMessage = "Có lỗi khi load cây thiết bị !";
                this.saveStatus = true;
            });

    }
    chonTree($event) {
        this.idThietBi = $event.id;
        this.thietbiChonGlobal = $event;
        this.mListTemp = [];
        let itemTemp: DMThietBi;
        var global = this;
        $("#lstview2_to option").each(function () {
            itemTemp = new DMThietBi();
            itemTemp.Id = ($(this).val());
            itemTemp.TenThietBi = ($(this).text());
            global.mListTemp.push(itemTemp);
        });
        this.GetListChild(1);
    }
    chonLoaiThietBi() {
        this.mListTemp = [];
        let itemTemp: DMThietBi;
        var global = this;
        $("#lstview2_to option").each(function () {
            itemTemp = new DMThietBi();
            itemTemp.Id = ($(this).val());
            itemTemp.TenThietBi = ($(this).text());
            global.mListTemp.push(itemTemp);
        });
        console.log(this.mListTemp);
        this.GetListChild(1);
    }
    GetListChild(paging: number) {
        let pageSize = 1000;
        this.serviceSanPham.GetListDeviceAll(paging, pageSize, "", this.IdDonVi, this.idThietBi, this.idLoaiThietBi)
            .subscribe(
            (data) => {
                this.listItemThietBi = data;
                $('#lstview2').multiselect();
                jQuery("#loader").modal('hide');
            },
            er => {
                if (er.status == 401) {
                    this.router.navigate(['./login']);
                }
                this.saveStatusMessage = "Có lỗi khi load danh sách thiết bị !";
                this.saveStatus = true;
            });
    }
    coppyThietBi(option: number) {
        this.thongBaoLuuNhanVien = false;
        this.coppingThietBi = true;
        let listDaiBieu = [];
        $("#lstview2_to option").each(function () {
            listDaiBieu.push($(this).val());
        });

        this.service.CoppyList(this.mQuyTrinh.Id, 1, option, listDaiBieu)
            .subscribe((data) => {
                listDaiBieu.length = 0;
                this.resetThietBi();
                this.coppingThietBi = false;
                $("#myModalListThietBi").modal("hide");
                this.GetListQuyTrinh(1);
            },
            error => {
            });
    }
    resetThietBi() {
        this.thietbiChonGlobal = { name: '--- Tất cả nhóm thiết bị---', id: 0 };
        this.mListTemp = [];
        this.listItemThietBi = [];
        this.idLoaiThietBi = 0;
        this.idThietBi = 0;
    }
    selectNhom() {
        this.isNhomThietBi = true;
        this.resetThietBi();
        this.GetListChild(1);
    }
    selectLoai() {
        this.isNhomThietBi = false;
        this.resetThietBi();
        this.GetListChild(1);
    }
    GetListLoaiThietBi() {
        this.loaithietbiService.GetListAll()
            .subscribe(
            (data) => {
                this.listLoaiThietBi = data;
            },
            er => {
                if (er.status == 401) {
                    this.router.navigate(['./login']);
                }
            });
    }
    GetListDongThietBi() {
        this.dongThietBiService.GetList_all(this.idHangThietBiSearch, this.idLoaiThietBiSearch)
            .subscribe(
            (data) => {
                this.listDongThietBI = data;
            },
            er => {
                if (er.status == 401) {
                    this.router.navigate(['./login']);
                }
            });
    }
    GetHangSanXuat() {
        this.hangsanxuatservice.GetList()
            .subscribe(
            (data) => {
                this.listHangSanXuat = data;
            },
            er => {
                if (er.status == 401) {
                    this.router.navigate(['./login']);
                }
            });
    }
    chonLoaiThietBiSearch() {
        this.GetListDongThietBi();
        this.idDongThietBiSearch = 0;
        this.search();
    }
    mTB: any = {};
    openDropTree: boolean = true;
    openExpanded($event){                
        this.openDropTree = $event;       
    }
    onselectThietBi($event) {
        this.mQuyTrinh.IdThietBi = $event.item.Id;
    }
    addQuytrinh() {
        this.Reset();
        this.saveStatusMessage = 'Đang load cây thiết bị ...';
        this.saveStatus = false;
        $("#loader").modal();
        this.serviceSanPham.GetTreeListGroup()
            .subscribe(
            (data) => {
                this.dmThietBiTreeData = data;
                $("#loader").modal('hide');
                $("#myModalAdd").modal();
                this.HideAlert("error", true);
            },
            er => {
                if (er.status == 401) {
                    this.router.navigate(['./login']);
                }
                this.saveStatusMessage = "Có lỗi khi load cây thiết bị !";
                this.saveStatus = true;
            });
    }
    Delete() {

    }
    DeleteCauHinhSMS() {

    }
    GetListTrangThai() {
        this.serviceTrangThai.GetListAll()
            .subscribe(
            (data) => {
                this.mListTrangThai = data;
                console.log(this.mListTrangThai);
            },
            er => {
                if (er.status == 401) {
                    this.router.navigate(['./login']);
                }
            });
    }
    changeTrangThai() {
        this.divTrangThai.nativeElement.hidden = true;
    }
    ShowAlert(message: string, option: string, pop: boolean = false) {
        if (pop) {
            if (option == "error") {
                this.messagePop = message;
                this.errorPop = true;
                //setTimeout(() => this.errorPop = false, 3000);
            }
            else {
                this.messagePop = message;
                this.statusPop = true;
            }
        }
        else {
            if (option == "success") {
                this.successMessage = message;
                this.success = true;
                setTimeout(() => this.success = false, 3000);
            }
            else if (option == "error") {
                this.errorMessage = message;
                this.error = true;
                //setTimeout(() => this.error = false, 3000);
            }
            else {
                this.statusMessage = message;
                this.status = true;
            }
        }
    }

    HideAlert(option: string, pop: boolean = false) {
        if (pop) {
            if (option == "error")
                this.errorPop = false;
            else
                setTimeout(() => this.statusPop = false, 1000);
        }
        else {
            if (option == "success")
                this.success = false;
            else if (option == "error")
                this.error = false;
            else
                setTimeout(() => this.status = false, 1000);
        }
    }
    ResetBuoc() {
        this.divGhiChu.nativeElement.hidden = true;
        this.mBuocThucHien = new BuocThucHien();
        this.mCauHinhSMSQuyTrinh = new CauHinhSMSQuyTrinh();
        this.donviChonSMS = { name: '--- Chọn đơn vị ---', id: 0 };
        this.showNhanVien = false;
        this.divCongViec.nativeElement.hidden = true;
        this.divTrangThai.nativeElement.hidden = true;
        //this.divCoQuan.nativeElement.hidden = true;
        this.divMaQuyTrinh.nativeElement.hidden = true;
    }
    getCauHinhBuoc(item: BuocThucHien) {
        this.mBuocThucHien = item;
        this.getListBuocSTT(item.IdQuyTrinh, item.Id);
        this.Load_DanhSachKetQuaXuLy();
        this.getListCauHinhBuoc();
    }
    getListCauHinhBuoc() {
        this.serviceCauHinhBuoc.GetList(this.mBuocThucHien.Id)
            .subscribe(
            (data) => {
                this.mListCauHinhBuoc = data;
            },
            er => {
                if (er.status == 401) {
                    this.router.navigate(['./login']);
                }
            });
    }
    chonKetQua(item, event: number) {
        //let cauhinh:any = _.find(users, function(o) { return o.age < 40; });

        //let cauhinh:KetQua = _.find(this.mListKetQua, function(o) { return o.Id = Number(event); });
        //let cauhinh:KetQua = _.find(this.mListKetQua, { 'Id': event});
        //console.log(this.mListKetQua);
        //console.log(cauhinh);
        this.getListBuocCauHinh(item.IdQuyTrinh, item.IdBuoc, item.Id, event);
        if (this.mListBuocSelectTemp.length > 0)
            item.IdBuocSau = this.mListBuocSelectTemp[0].Id;
        else
            item.IdBuocSau = 0;

    }
    getListBuocCauHinh(idQuyTrinh: number, idBuoc: number, idCauHinh: number, idKetQua: number) {
        this.serviceBuocThucHien.GetListCauHinh(idQuyTrinh, idBuoc, idCauHinh, idKetQua)
            .subscribe(
            (data) => {
                this.mListBuocSelectTemp = data;
                console.log(this.mListBuocSelectTemp);
            },
            er => {
                if (er.status == 401) {
                    this.router.navigate(['./login']);
                }
            });
    }
    getListBuocSTT(idQuyTrinh: number, idBuoc: number) {
        this.serviceBuocThucHien.GetListSelect(idQuyTrinh, idBuoc)
            .subscribe(
            (data) => {
                this.mListBuocSelect = data;
            },
            er => {
                if (er.status == 401) {
                    this.router.navigate(['./login']);
                }
            });
    }
    Load_DanhSachKetQuaXuLy() {
        this.serviceKQXL.DanhSach_KetQuaXuLy().subscribe(
            resp => {
                this.mListKetQua = resp;
            }
        )
    }
    Load_DanhSachKetQuaXuLyBuoc(IdBuoc: number, IdCauHinhBuoc: number) {
        this.serviceKQXL.KetQuaXuLy_BuocThucHien(IdBuoc, IdCauHinhBuoc).subscribe(
            resp => {
                this.mListKetQuaTemp = resp;
            }
        )
    }
    AddCauHinhBuoc() {
        var item: CauHinhBuoc = new CauHinhBuoc();
        item.IdQuyTrinh = this.mQuyTrinh.Id;
        item.IdBuoc = this.mBuocThucHien.Id;
        item.IdKetQua = 0;
        item.IdBuocSau = 0;
        item.EditAble = true;
        this.mListCauHinhBuoc.push(item);
        this.mListBuocSelectTemp = [];
        this.Load_DanhSachKetQuaXuLyBuoc(this.mBuocThucHien.Id, 0);
    }
    ChonEdit(item: CauHinhBuoc) {
        this.serviceCauHinhBuoc.GetList(this.mBuocThucHien.Id)
            .subscribe(
            (data) => {
                this.mListCauHinhBuoc = data;
                this.mListCauHinhBuoc.forEach(element => {
                    if (element.Id === item.Id) {
                        element.EditAble = true;
                    }
                });
                this.Load_DanhSachKetQuaXuLyBuoc(item.IdBuoc, item.Id);
                this.getListBuocCauHinh(item.IdQuyTrinh, item.IdBuoc, item.Id, item.IdKetQua);
            },
            er => {
                if (er.status == 401) {
                    this.router.navigate(['./login']);
                }
            });


    }

    luuCauHinhBuoc(item: CauHinhBuoc) {
        this.saveStatusMessage = "Đang xử lý vui lòng chờ";
        this.saveStatus = false;

        item.Saving = true;
        item.EditAble = false;
        this.serviceCauHinhBuoc.Save(item).subscribe(
            (resp) => {
                if (resp.Success) {
                    this.getListCauHinhBuoc();
                }
                else {
                    this.saveStatusMessage = "Lỗi khi thêm cấu hình cho bước! Xin vui lòng thực hiện lại sau";
                    this.saveStatus = false;
                }
            },
            (er) => {
                if (er.status == 401) {
                    this.router.navigate(['./login']);
                }
                console.log(er);
                this.saveStatusMessage = "Lỗi khi lưu dữ liệu! Xin vui lòng thực hiện lại sau";
                this.saveStatus = false;
            }
        )
    }
    DeleteCauHinhBuoc(i: number, ds: CauHinhBuoc) {
        this.mListCauHinhBuoc.splice(i, 1);
        if (ds.Id != 0) {
            this.serviceCauHinhBuoc.Delete(ds).subscribe(
                (resp) => {
                    if (resp.Success) {
                        this.getListCauHinhBuoc();
                    }
                    else {
                        this.saveStatusMessage = "Lỗi khi xoá cấu hình cho bước ! Xin vui lòng thực hiện lại sau";
                        this.saveStatus = false;
                        //jQuery("#loader").modal();
                    }
                },
                (er) => {
                    if (er.status == 401) {
                        this.router.navigate(['./login']);
                    }
                    console.log(er);
                    this.saveStatusMessage = "Lỗi khi lưu dữ liệu! Xin vui lòng thực hiện lại sau";
                    this.saveStatus = false;
                }
            )
        }
    }

    updateSTT() {

        this.service.CheckYeuCau(this.mQuyTrinh.Id).subscribe((resp) => {
            if (resp.flag == 1) {
                $("#modalConfirmSXBuoc").modal();
            }
            else {
                this.TT = false;
                this.saveStatusMessage = "Đang phát sinh yêu cầu tại quy trình! Vui lòng xử lý hoặc kiểm tra lại!";
                $("#ThongBao").modal({ backdrop: 'static', keyboard: true });
            }
        },
            (er) => {
                $("#modalConfirmSXBuoc").modal();
            });
    }

    fileList = [];
    fileListDisplay:any[]=[];
    fileChange(event) {
        this.fileList = event.target.files;
        for (let i = 0; i < this.fileList.length; i++) {
          this.fileListDisplay.push({ name: this.fileList[i].name, file: this.fileList[i] });
        }
    }
    removeFileItem(i) {
        this.fileListDisplay.splice(i, 1);
    }

    Luu_anhquytrinh(IdQuyTrinh){
        let formData = new FormData();
        let datafile=[];
        for (let i = 0; i < this.fileListDisplay.length; i++) {
            let file: File = this.fileListDisplay[i].file;
            if(file !== undefined)
              formData.append('luu_anhquytrinh', file, file.name);
            else{
              let item = {                
                filename:this.fileListDisplay[i].name
              }
              datafile.push(item);
            }
        }
        formData.append("idquytrinh",IdQuyTrinh);
        if(datafile.length>0)
        formData.append("datafile",JSON.stringify(datafile));
        this.svQTXL.luu_anhquytrinh(formData).subscribe(resp=>{});
    }
    Load_dsAnhQuyTrinh(IdQuyTrinh){
        this.svQTXL.ds_anhquytrinh(IdQuyTrinh).subscribe(
            resp=>{
                this.fileListDisplay = resp;
            }
        );
    }
}



// WEBPACK FOOTER //
// D:/1.eGovD/CITIZEN/sources/citizen-admin/Angular/src/app/quy-trinh-xu-ly-thiet-bi/quy-trinh-xu-ly-thiet-bi.component.ts